export type EditorTicketType = ObjectValues<typeof EDITOR_TICKET_TYPE>

export const EDITOR_TICKET_TYPE = {
  PrepaidSubscription: 'PrepaidSubscription',
  Single: 'Single',
  Subscription: 'Subscription',
} as const

export const EDITOR_ADD_ON_ACTIVE_VALUE = 'true'

export const EDITOR_PREPAID_SUBSCRIPTION_CUSTOM_LABEL = 'custom'

export const EDITOR_PREPAID_SUBSCRIPTION_DEFAULT_DRAWS_MAX = 100

export const EDITOR_PREPAID_SUBSCRIPTION_DEFAULT_DRAWS_MIN = 4
